import React from 'react'
import { TYRE_TYPES } from '../../../constants/tyreTypes'

const TyreTypeSvg = (props) => {
  const { type, ...rest } = props
  switch(type) {
    case TYRE_TYPES.ALL_SEASON.id:
      return <AllSeasonSvg {...rest} />
    case TYRE_TYPES.WINTER.id:
      return <SnowflakeSvg {...rest} />
    case TYRE_TYPES.NORDIC_WINTER.id:
      return <NoWinterSvg {...rest} />
    case TYRE_TYPES.EU_WINTER.id:
      return <EuWinterSvg {...rest} />
    case TYRE_TYPES.STUDDED.id:
      return <StuddedSvg {...rest} />
    case TYRE_TYPES.STUDDABLE.id:
      return <StuddableSvg {...rest} />
    case TYRE_TYPES.SUMMER.id:
      return <SunSvg {...rest} />
    default:
      return null
  }
}

const AllSeasonSvg = (props) => {
  const { className, ...rest } = props
  return (
    <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_all_season</title>
      <g id="Icon_Sun" transform="matrix(1, 0, 0, 1, -42, -112)" stroke="none" fill="none">
        <path d="M 45.026 117.547 L 47.612 114.961 L 50.722 118.053 L 48.119 120.639 Z M 49.304 118.053 L 47.614 116.373 L 46.44 117.547 L 48.121 119.227 Z M 41.833 128.767 L 41.833 125.1 L 46.833 125.1 L 46.833 128.767 Z M 45.833 126.1 L 42.833 126.1 L 42.833 127.767 L 45.833 127.767 Z M 55.167 116.767 L 55.167 111.833 L 58.833 111.833 L 58.833 116.767 Z M 57.833 112.833 L 56.167 112.833 L 56.167 115.767 L 57.833 115.767 Z M 63.293 118.053 L 66.387 114.96 L 68.974 117.547 L 65.88 120.64 Z M 67.56 117.547 L 66.387 116.374 L 64.707 118.053 L 65.88 119.226 Z M 50.706 135.799 L 47.614 138.908 L 45.027 136.321 L 48.119 133.212 Z M 46.439 136.319 L 47.612 137.492 L 49.294 135.801 L 48.121 134.628 Z" className={className} />
        <path d="M 221.502 576.868 C 170.349 520.723 156.919 444.905 176.22 381.562 C 195.522 318.22 248.735 261.848 322.719 244.695 C 390.51 228.978 464.244 251.646 512.882 301.421 L 520.803 309.528 L 512.525 317.445 L 375.737 448.281 L 229.135 585.246 Z M 360.215 431.764 L 488.509 309.052 C 445.362 268.311 390.166 252.325 327.839 266.775 C 259.975 282.509 215.738 329.635 197.902 388.169 C 180.066 446.703 188.767 504.064 230.458 552.991 Z" className={className} transform="matrix(0.044119, 0, 0, 0.044119, 41.01178, 107.756592)"/>
        <g id="Icon_Flake" transform="matrix(1, 0, 0, 1, -48.471695, 0.626576)" stroke="none" fill="none">
          <path d="M 114.98 128.833 L 118.799 132.652 L 116.214 135.255 L 109.793 128.833 L 107.833 128.833 L 107.833 130.793 L 114.255 137.214 L 111.652 139.799 L 107.833 135.98 L 107.833 140.833 L 104.167 140.833 L 104.167 135.98 L 100.348 139.799 L 97.745 137.214 L 104.167 130.793 L 109.793 125.167 L 116.214 118.745 L 118.799 121.348 L 114.98 125.167 L 119.833 125.167 L 119.833 128.833 L 114.98 128.833 Z M 118.833 126.167 L 112.566 126.167 L 117.387 121.346 L 116.212 120.161 L 110.207 126.167 L 105.167 131.207 L 99.161 137.212 L 100.346 138.387 L 105.167 133.566 L 105.167 139.833 L 106.833 139.833 L 106.833 133.566 L 111.654 138.387 L 112.839 137.212 L 106.833 131.207 L 106.833 127.833 L 110.207 127.833 L 116.212 133.839 L 117.387 132.654 L 112.566 127.833 L 118.833 127.833 L 118.833 126.167 Z" className={className} />
        </g>
      </g>
    </svg>
  )
}

const SnowflakeSvg = (props) => {
  const { className, ...rest } = props
  return (
    <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_ac_unit</title>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-92.000000, -113.000000)">
          <g id="ic_ac_unit" transform="translate(90.000000, 111.000000)">
            <polygon id="Bounds" points="0 0 32 0 32 32 0 32"></polygon>
            <polygon id="Icon" className={className} points="29.3333333 14.6666667 23.7733333 14.6666667 28.0933333 10.3466667 26.2133333 8.45333333 20 14.6666667 17.3333333 14.6666667 17.3333333 12 23.5466667 5.78666667 21.6533333 3.90666667 17.3333333 8.22666667 17.3333333 2.66666667 14.6666667 2.66666667 14.6666667 8.22666667 10.3466667 3.90666667 8.45333333 5.78666667 14.6666667 12 14.6666667 14.6666667 12 14.6666667 5.78666667 8.45333333 3.90666667 10.3466667 8.22666667 14.6666667 2.66666667 14.6666667 2.66666667 17.3333333 8.22666667 17.3333333 3.90666667 21.6533333 5.78666667 23.5466667 12 17.3333333 14.6666667 17.3333333 14.6666667 20 8.45333333 26.2133333 10.3466667 28.0933333 14.6666667 23.7733333 14.6666667 29.3333333 17.3333333 29.3333333 17.3333333 23.7733333 21.6533333 28.0933333 23.5466667 26.2133333 17.3333333 20 17.3333333 17.3333333 20 17.3333333 26.2133333 23.5466667 28.0933333 21.6533333 23.7733333 17.3333333 29.3333333 17.3333333"></polygon>
          </g>
        </g>
      </g>
    </svg>
  )
}

const SunSvg = (props) => {
  const { className, ...rest } = props
  return (
    <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_wb_sunny</title>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-42.000000, -112.000000)">
          <g id="ic_wb_sunny" transform="translate(41.000000, 111.000000)">
            <polygon id="Bounds" points="0 0 32 0 32 32 0 32"></polygon>
            <path  className={className} d="M9.01333333,7.05333333 L6.61333333,4.66666667 L4.73333333,6.54666667 L7.12,8.93333333 L9.01333333,7.05333333 L9.01333333,7.05333333 Z M5.33333333,14.6 L1.33333333,14.6 L1.33333333,17.2666667 L5.33333333,17.2666667 L5.33333333,14.6 L5.33333333,14.6 Z M17.3333333,1.33333333 L14.6666667,1.33333333 L14.6666667,5.26666667 L17.3333333,5.26666667 L17.3333333,1.33333333 L17.3333333,1.33333333 Z M27.2666667,6.54666667 L25.3866667,4.66666667 L23,7.05333333 L24.88,8.93333333 L27.2666667,6.54666667 L27.2666667,6.54666667 Z M22.9866667,24.8133333 L25.3733333,27.2133333 L27.2533333,25.3333333 L24.8533333,22.9466667 L22.9866667,24.8133333 L22.9866667,24.8133333 Z M26.6666667,14.6 L26.6666667,17.2666667 L30.6666667,17.2666667 L30.6666667,14.6 L26.6666667,14.6 L26.6666667,14.6 Z M16,7.93333333 C11.5866667,7.93333333 8,11.52 8,15.9333333 C8,20.3466667 11.5866667,23.9333333 16,23.9333333 C20.4133333,23.9333333 24,20.3466667 24,15.9333333 C24,11.52 20.4133333,7.93333333 16,7.93333333 L16,7.93333333 Z M14.6666667,30.5333333 L17.3333333,30.5333333 L17.3333333,26.6 L14.6666667,26.6 L14.6666667,30.5333333 L14.6666667,30.5333333 Z M4.73333333,25.32 L6.61333333,27.2 L9,24.8 L7.12,22.92 L4.73333333,25.32 L4.73333333,25.32 Z" id="Icon"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const NoWinterSvg = (props) => {
  const { className, ...rest } = props
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_nordic</title>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-143.000000, -111.000000)">
          <g id="ic_nordic" transform="translate(143.000000, 111.000000)">
            <polygon id="Bounds" points="4 4 28 4 28 28 4 28"></polygon>
            <path className={className} d="M26.8844781,17.6 C26.8205778,18.038512 26.7308064,18.4686325 26.6167627,18.8887627 L30.512,22.784 L28.256,25.056 L25.2127461,22.0127461 C24.3789607,23.2876742 23.2876742,24.3789607 22.0127461,25.2127461 L25.056,28.256 L22.784,30.512 L18.8887627,26.6167627 C18.4686325,26.7308064 18.038512,26.8205778 17.6,26.8844781 L17.6,32 L14.4,32 L14.4,26.8844781 C13.961488,26.8205778 13.5313675,26.7308064 13.1112373,26.6167627 L9.216,30.512 L6.944,28.256 L9.98725392,25.2127461 C8.71232582,24.3789607 7.62103932,23.2876742 6.78725392,22.0127461 L3.744,25.056 L1.488,22.784 L5.38323733,18.8887627 C5.26919357,18.4686325 5.17942219,18.038512 5.1155219,17.6 L0,17.6 L0,14.4 L5.1155219,14.4 C5.17942219,13.961488 5.26919357,13.5313675 5.38323733,13.1112373 L1.488,9.216 L3.744,6.944 L6.78725392,9.98725392 C7.62103932,8.71232582 8.71232582,7.62103932 9.98725392,6.78725392 L6.944,3.744 L9.216,1.488 L13.1112373,5.38323733 C13.5313675,5.26919357 13.961488,5.17942219 14.4,5.1155219 L14.4,0 L17.6,0 L17.6,5.1155219 C18.038512,5.17942219 18.4686325,5.26919357 18.8887627,5.38323733 L22.784,1.488 L25.056,3.744 L22.0127461,6.78725392 C23.2876742,7.62103932 24.3789607,8.71232582 25.2127461,9.98725392 L28.256,6.944 L30.512,9.216 L26.6167627,13.1112373 C26.7308064,13.5313675 26.8205778,13.961488 26.8844781,14.4 L32,14.4 L32,17.6 L26.8844781,17.6 Z M9.435,12.77 L8.73,12.77 L8.73,20 L9.915,20 L9.915,15.56 C9.915,15.4733329 9.91250002,15.3775005 9.9075,15.2725 C9.90249997,15.1674995 9.89500005,15.0616672 9.885,14.955 L13.665,19.77 C13.731667,19.8566671 13.7999997,19.9166665 13.87,19.95 C13.9400004,19.9833335 14.0283328,20 14.135,20 L14.83,20 L14.83,12.77 L13.645,12.77 L13.645,17.165 C13.645,17.2616672 13.6475,17.3658328 13.6525,17.4775 C13.6575,17.5891672 13.6666666,17.7033328 13.68,17.82 L9.885,12.985 C9.84833315,12.9383331 9.81500015,12.9008335 9.785,12.8725 C9.75499985,12.8441665 9.72416683,12.8225001 9.6925,12.8075 C9.66083318,12.7924999 9.6250002,12.7825 9.585,12.7775 C9.5449998,12.7725 9.4950003,12.77 9.435,12.77 Z M23.5821429,16.385 C23.5821429,15.8549974 23.4938104,15.3641689 23.3171429,14.9125 C23.1404753,14.4608311 22.8921445,14.070835 22.5721429,13.7425 C22.2521413,13.414165 21.8671451,13.1566676 21.4171429,12.97 C20.9671407,12.7833324 20.4688123,12.69 19.9221429,12.69 C19.3754735,12.69 18.8763118,12.7824991 18.4246429,12.9675 C17.972974,13.1525009 17.5863112,13.4099984 17.2646429,13.74 C16.9429746,14.0700017 16.6938105,14.4608311 16.5171429,14.9125 C16.3404754,15.3641689 16.2521429,15.8549974 16.2521429,16.385 C16.2521429,16.9150026 16.3404754,17.4058311 16.5171429,17.8575 C16.6938105,18.3091689 16.9429746,18.6999984 17.2646429,19.03 C17.5863112,19.3600017 17.972974,19.6174991 18.4246429,19.8025 C18.8763118,19.9875009 19.3754735,20.08 19.9221429,20.08 C20.4688123,20.08 20.9671407,19.9875009 21.4171429,19.8025 C21.8671451,19.6174991 22.2521413,19.3600017 22.5721429,19.03 C22.8921445,18.6999984 23.1404753,18.3091689 23.3171429,17.8575 C23.4938104,17.4058311 23.5821429,16.9150026 23.5821429,16.385 Z M22.2021429,16.385 C22.2021429,16.7816687 22.1496434,17.1374984 22.0446429,17.4525 C21.9396424,17.7675016 21.7888106,18.0341656 21.5921429,18.2525 C21.3954753,18.4708344 21.156311,18.6383328 20.8746429,18.755 C20.5929748,18.8716673 20.275478,18.93 19.9221429,18.93 C19.5688078,18.93 19.2504777,18.8716673 18.9671429,18.755 C18.6838082,18.6383328 18.4429772,18.4708344 18.2446429,18.2525 C18.0463086,18.0341656 17.8938101,17.7675016 17.7871429,17.4525 C17.6804757,17.1374984 17.6271429,16.7816687 17.6271429,16.385 C17.6271429,15.9883313 17.6804757,15.6325016 17.7871429,15.3175 C17.8938101,15.0024984 18.0463086,14.7350011 18.2446429,14.515 C18.4429772,14.2949989 18.6838082,14.1266673 18.9671429,14.01 C19.2504777,13.8933328 19.5688078,13.835 19.9221429,13.835 C20.275478,13.835 20.5929748,13.8933328 20.8746429,14.01 C21.156311,14.1266673 21.3954753,14.2949989 21.5921429,14.515 C21.7888106,14.7350011 21.9396424,15.0024984 22.0446429,15.3175 C22.1496434,15.6325016 22.2021429,15.9883313 22.2021429,16.385 Z" id="Combined-Shape"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const EuWinterSvg = (props) => {
  const { className, ...rest } = props
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_european</title>
      <desc>Created with Sketch.</desc>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-201.000000, -111.000000)">
          <g id="ic_european" transform="translate(201.000000, 111.000000)">
            <polygon id="Bounds" points="4 4 28 4 28 28 4 28"></polygon>
            <path className={className} d="M26.8844781,17.6 C26.8205778,18.038512 26.7308064,18.4686325 26.6167627,18.8887627 L30.512,22.784 L28.256,25.056 L25.2127461,22.0127461 C24.3789607,23.2876742 23.2876742,24.3789607 22.0127461,25.2127461 L25.056,28.256 L22.784,30.512 L18.8887627,26.6167627 C18.4686325,26.7308064 18.038512,26.8205778 17.6,26.8844781 L17.6,32 L14.4,32 L14.4,26.8844781 C13.961488,26.8205778 13.5313675,26.7308064 13.1112373,26.6167627 L9.216,30.512 L6.944,28.256 L9.98725392,25.2127461 C8.71232582,24.3789607 7.62103932,23.2876742 6.78725392,22.0127461 L3.744,25.056 L1.488,22.784 L5.38323733,18.8887627 C5.26919357,18.4686325 5.17942219,18.038512 5.1155219,17.6 L0,17.6 L0,14.4 L5.1155219,14.4 C5.17942219,13.961488 5.26919357,13.5313675 5.38323733,13.1112373 L1.488,9.216 L3.744,6.944 L6.78725392,9.98725392 C7.62103932,8.71232582 8.71232582,7.62103932 9.98725392,6.78725392 L6.944,3.744 L9.216,1.488 L13.1112373,5.38323733 C13.5313675,5.26919357 13.961488,5.17942219 14.4,5.1155219 L14.4,0 L17.6,0 L17.6,5.1155219 C18.038512,5.17942219 18.4686325,5.26919357 18.8887627,5.38323733 L22.784,1.488 L25.056,3.744 L22.0127461,6.78725392 C23.2876742,7.62103932 24.3789607,8.71232582 25.2127461,9.98725392 L28.256,6.944 L30.512,9.216 L26.6167627,13.1112373 C26.7308064,13.5313675 26.8205778,13.961488 26.8844781,14.4 L32,14.4 L32,17.6 L26.8844781,17.6 Z M14.29,12.77 L9.73,12.77 L9.73,20 L14.29,20 L14.29,18.925 L11.085,18.925 L11.085,16.88 L13.61,16.88 L13.61,15.845 L11.085,15.845 L11.085,13.84 L14.29,13.84 L14.29,12.77 Z M18.7221429,18.915 C18.4621416,18.915 18.2296439,18.8716671 18.0246429,18.785 C17.8196419,18.6983329 17.6471436,18.5758341 17.5071429,18.4175 C17.3671422,18.2591659 17.2596433,18.0683344 17.1846429,17.845 C17.1096425,17.6216655 17.0721429,17.371668 17.0721429,17.095 L17.0721429,12.77 L15.7271429,12.77 L15.7271429,17.1 C15.7271429,17.5300021 15.7963089,17.9274982 15.9346429,18.2925 C16.0729769,18.6575018 16.2713083,18.9724987 16.5296429,19.2375 C16.7879775,19.5025013 17.1021411,19.7091659 17.4721429,19.8575 C17.8421448,20.0058341 18.2588073,20.08 18.7221429,20.08 C19.1854786,20.08 19.6021411,20.0058341 19.9721429,19.8575 C20.3421448,19.7091659 20.6571416,19.5025013 20.9171429,19.2375 C21.1771442,18.9724987 21.3763089,18.6575018 21.5146429,18.2925 C21.6529769,17.9274982 21.7221429,17.5300021 21.7221429,17.1 L21.7221429,12.77 L20.3771429,12.77 L20.3771429,17.1 C20.3771429,17.376668 20.3396433,17.6266655 20.2646429,17.85 C20.1896425,18.0733344 20.0813103,18.2633325 19.9396429,18.42 C19.7979755,18.5766674 19.6246439,18.6983329 19.4196429,18.785 C19.2146419,18.8716671 18.9821442,18.915 18.7221429,18.915 Z" id="Combined-Shape"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const StuddedSvg = (props) => {
const { className, ...rest } = props
  return (
    <svg width="20px" height="20px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_studded</title>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-269.000000, -51.000000)">
          <g id="ic_studded" transform="translate(277.000000, 56.000000) rotate(180.000000) translate(-277.000000, -56.000000) translate(265.000000, 44.000000)">
            <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M19.28,7.16858861 C18.9846392,6.9438038 4.29536082,6.9438038 4,7.16858861 L11.6334364,16.7483887 L19.28,7.16858861 Z" id="Icon" className={className}></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const StuddableSvg = (props) => {
const { className, ...rest } = props
  return (
    <svg width="20px" height="20px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <title>ic_studdable</title>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-269.000000, -51.000000)">
          <g id="ic_studdable" transform="translate(277.000000, 56.000000) rotate(180.000000) translate(-277.000000, -56.000000) translate(265.000000, 44.000000)">
            <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M19.28,7.16858861 C18.9846392,6.9438038 4.29536082,6.9438038 4,7.16858861 L11.6334364,16.7483887 L19.28,7.16858861 Z" id="Icon" className={className}></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const WheelBuilderActiveItemSvg = (props) => {
  const { className, strokeClass } = props
  return (
    <svg width="35px" height="35px" viewBox="0 0 35 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>ic_progress_selected</title>
      <desc>Created with Sketch.</desc>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-465.000000, -236.000000)" fillRule="nonzero" className={strokeClass} strokeWidth="2">
          <g id="ic_progress_selected" transform="translate(466.000000, 237.000000)">
            <circle id="Oval-2" fill="#FFFFFF" cx="16.5" cy="16.5" r="16.5"></circle>
            <circle id="Oval-2" className={className} cx="16.5" cy="16.5" r="6.5"></circle>
          </g>
        </g>
      </g>
    </svg>
  )
}

const WheelBuilderSelectedItemSvg = (props) => {
  const { className } = props
  return (
    <svg width="35px" height="35px" viewBox="0 0 35 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>ic_progress_done</title>
      <desc>Created with Sketch.</desc>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Icons" transform="translate(-608.000000, -236.000000)">
              <g id="ic_progress_done" transform="translate(609.000000, 237.000000)">
                  <g id="Group-11">
                      <circle id="Oval-2" strokeWidth="2" className={className} fillRule="nonzero" cx="16.5" cy="16.5" r="16.5"></circle>
                      <polygon id="Bounds" points="5 5 29 5 29 29 5 29"></polygon>
                      <polygon id="Icon" fill="#FFFFFF" points="13.59 21.58 9.42 17.41 8 18.82 13.59 24.41 25.59 12.41 24.18 11"></polygon>
                  </g>
              </g>
          </g>
      </g>
    </svg>
  )
}

const WheelBuilderNormalItemSvg = (props) => {
  return (
    <svg width="35px" height="35px" viewBox="0 0 35 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>ic_progress_normal</title>
        <desc>Created with Sketch.</desc>
        <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Icons" transform="translate(-348.000000, -236.000000)" fill="#F8F8F8" fillRule="nonzero" stroke="#E0E0E0" strokeWidth="2">
                <circle id="ic_progress_normal" cx="365.5" cy="253.5" r="16.5"></circle>
            </g>
        </g>
    </svg>
  )
}

const CheckedSvg = (props) => {
  const { className } = props
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>check on</title>
      <desc>Created with Sketch.</desc>
      <g id="eontyre-design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="complete-wheels-2" transform="translate(-805.000000, -354.000000)">
          <g id="Group-25" transform="translate(802.000000, 323.000000)">
            <g id="check-on" transform="translate(0.000000, 28.000000)">
              <rect id="bounds" x="0" y="0" width="24" height="24"></rect>
              <path  className={className} d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 L19,3 Z M10,17 L5,12.1923077 L6.4,10.8461538 L10,14.3076923 L17.6,7 L19,8.34615385 L10,17 L10,17 Z" id="Shape"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const UncheckedSvg = (props) => {
  const { className } = props
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>check off</title>
      <desc>Created with Sketch.</desc>
      <g id="eontyre-design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="complete-wheels-2" transform="translate(-805.000000, -388.000000)">
          <g id="Group-25" transform="translate(802.000000, 323.000000)">
            <g id="check-off" transform="translate(0.000000, 62.000000)">
              <rect id="bounds" x="0" y="0" width="24" height="24"></rect>
              <path d="M19,5 L19,19 L5,19 L5,5 L19,5 L19,5 Z M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 L19,3 L19,3 Z" id="Shape" className={className} opacity="0.54"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const GripGradeSvg = (props) => {
  const { className } = props
  return (
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-521.000000, -115.000000)" className={className} fillRule="nonzero">
          <g id="ic_clouds" transform="translate(521.000000, 115.000000)">
            <path d="M21.6538776,7.20066972 C21.7689796,6.73908833 21.84,6.25754666 21.84,5.75853975 C21.837551,2.57737069 19.3102041,0 16.1877551,0 C13.6457143,0 11.4955102,1.7115937 10.7853061,4.06441129 C10.1167347,3.45312782 9.24489796,3.07138753 8.27510204,3.07138753 C6.3722449,3.07138753 4.8122449,4.51601254 4.56,6.38728846 C1.99591837,6.67421743 0,8.9322237 0,11.6218709 C0,14.5036359 2.2922449,16.8888889 5.12081633,16.8888889 C7.95183673,16.8888889 16.0457143,16.8888889 18.8742857,16.8888889 C21.7077551,16.8888889 24,14.5036359 24,11.6218709 C24,9.78303048 23.0620408,8.13880271 21.6538776,7.20066972 Z" id="Shape"></path>
            <path d="M10.6666667,22.5193211 C10.6666667,23.3379078 11.2650407,24 12,24 C12.7371274,24 13.3333333,23.3355002 13.3333333,22.5193211 C13.3333333,21.0386421 12,19.5555556 12,19.5555556 C12,19.5555556 10.6666667,21.0386421 10.6666667,22.5193211 Z" id="Shape"></path>
            <path d="M16,19.8526544 C16,20.6712411 16.598374,21.3333333 17.3333333,21.3333333 C18.0704607,21.3333333 18.6666667,20.6688335 18.6666667,19.8526544 C18.6666667,18.3719754 17.3333333,16.8888889 17.3333333,16.8888889 C17.3333333,16.8888889 16,18.3719754 16,19.8526544 Z" id="Shape"></path>
            <path d="M5.33333333,19.8526544 C5.33333333,20.6712411 5.93170732,21.3333333 6.66666667,21.3333333 C7.40379404,21.3333333 8,20.6688335 8,19.8526544 C8,18.3719754 6.66666667,16.8888889 6.66666667,16.8888889 C6.66666667,16.8888889 5.33333333,18.3719754 5.33333333,19.8526544 Z" id="Shape"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const FuelGradeSvg = (props) => {
  const { className } = props
  return (
    <svg width="18px" height="18px" viewBox="0 0 17 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-469.000000, -118.000000)">
          <g id="ic_local_gas_station" transform="translate(465.000000, 115.000000)">
            <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M19.77,7.23 L19.78,7.22 L16.06,3.5 L15,4.56 L17.11,6.67 C16.17,7.03 15.5,7.93 15.5,9 C15.5,10.38 16.62,11.5 18,11.5 C18.36,11.5 18.69,11.42 19,11.29 L19,18.5 C19,19.05 18.55,19.5 18,19.5 C17.45,19.5 17,19.05 17,18.5 L17,14 C17,12.9 16.1,12 15,12 L14,12 L14,5 C14,3.9 13.1,3 12,3 L6,3 C4.9,3 4,3.9 4,5 L4,21 L14,21 L14,13.5 L15.5,13.5 L15.5,18.5 C15.5,19.88 16.62,21 18,21 C19.38,21 20.5,19.88 20.5,18.5 L20.5,9 C20.5,8.31 20.22,7.68 19.77,7.23 L19.77,7.23 Z M12,10 L6,10 L6,5 L12,5 L12,10 L12,10 Z M18,10 C17.45,10 17,9.55 17,9 C17,8.45 17.45,8 18,8 C18.55,8 19,8.45 19,9 C19,9.55 18.55,10 18,10 L18,10 Z" id="Icon" className={className}></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const NoiseGradeSvg = (props) => {
  const { className } = props
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-589.000000, -118.000000)">
          <g id="ic_volume_up" transform="translate(586.000000, 115.000000)">
            <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M3,9 L3,15 L7,15 L12,20 L12,4 L7,9 L3,9 L3,9 Z M16.5,12 C16.5,10.23 15.48,8.71 14,7.97 L14,16.02 C15.48,15.29 16.5,13.77 16.5,12 L16.5,12 Z M14,3.23 L14,5.29 C16.89,6.15 19,8.83 19,12 C19,15.17 16.89,17.85 14,18.71 L14,20.77 C18.01,19.86 21,16.28 21,12 C21,7.72 18.01,4.14 14,3.23 L14,3.23 Z" id="Icon" className={className}></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

const CartSvg = (props) => {
  const { className, onClick } = props
  return (
    <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-135.000000, -52.000000)">
          <g id="ic_cart-" transform="translate(131.000000, 48.000000)">
            <g id="Cart" transform="translate(4.000000, 4.000000)">
              <path d="M17,4.85714286 L13.3571429,4.85714286 L13.3571429,0 L3.64285714,0 L3.64285714,4.85714286 L0,4.85714286 L0,17 L17,17 L17,4.85714286 Z M6.07142857,2.42857143 L10.9285714,2.42857143 L10.9285714,4.85714285 L6.07142857,4.85714291 L6.07142857,2.42857143 Z" id="Icons/Job" className={className}></path>
            </g>
            <g id="ic_ac_unit">
              <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const RadioCheckedSvg = (props) => {
  const { className, height } = props
  const size = height ? `${height}px`: '20px'
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="eontyre-design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="complete-wheels-1" transform="translate(-511.000000, -349.000000)">
          <g id="Group-3" transform="translate(509.000000, 323.000000)">
            <g id="ic_radio_button_checked" transform="translate(0.000000, 24.000000)">
              <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
              <path d="M12,7 C9.24,7 7,9.24 7,12 C7,14.76 9.24,17 12,17 C14.76,17 17,14.76 17,12 C17,9.24 14.76,7 12,7 L12,7 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M12,20 C7.58,20 4,16.42 4,12 C4,7.58 7.58,4 12,4 C16.42,4 20,7.58 20,12 C20,16.42 16.42,20 12,20 L12,20 Z" id="Icon" className={className}></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const RadioUncheckedSvg = (props) => {
  const { className, height } = props
  const size = height ? `${height}px`: '20px'
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="eontyre-design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="complete-wheels-1" transform="translate(-511.000000, -383.000000)">
          <g id="Group-3" transform="translate(509.000000, 323.000000)">
            <g id="ic_radio_button_unchecked" transform="translate(0.000000, 58.000000)">
              <polygon id="Bounds" points="0 0 24 0 24 24 0 24"></polygon>
              <path opacity="0.54" d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M12,20 C7.58,20 4,16.42 4,12 C4,7.58 7.58,4 12,4 C16.42,4 20,7.58 20,12 C20,16.42 16.42,20 12,20 L12,20 Z" id="Icon" className={className}></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const StarSvg = (props) => {
  const { className, height, width } = props
  return (
    <svg width={width} height={height} viewBox="0 0 13 12" version="1.1">
      <g id="eontyre-design-system" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-642.000000, -120.000000)">
          <g id="ic_stars-" transform="translate(641.408000, 119.000000)">
            <polygon id="Bounds" points="0 0 14 0 14 14 0 14"/>
            <polygon id="Icon" className={className} points="10.605 12.25 9.65125 8.14975 12.8333333 5.39233333 8.63858333 5.03241667 7 1.16666667 5.36141667 5.03241667 1.16666667 5.39233333 4.34875 8.14975 3.395 12.25 7 10.0753333"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

const SnowGripSvg = (props) => {
  const { className } = props
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 393.98 358.65" className={className} height="18px" width="18px">
    <path stroke="#1D1D1B" strokeMiterlimit={10} d="M19.48,345.11h353.14L245.58,80.55l-11.66,32.05l-47.78-99.06l-81.58,199.3c0,0-22-32.2-23.75-31.32
      C79.06,182.38,19.48,345.11,19.48,345.11z" />
    <g>
      <g>
        <g>
          <rect x="204.24" y="247.28" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  width="5.42" height="77.19"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="186.63,317.61 182.8,313.87 205.03,292.19 208.86,295.93 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="227.25,317.61 205.03,295.93 208.86,292.19 231.08,313.87 			"/>
        </g>
      </g>
      <g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="274.14,288.17 205.59,249.56 208.3,244.99 276.85,283.58 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="254,300.96 245.87,271.36 251.11,269.99 259.25,299.59 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="249.19,273.22 247.79,268.11 278.15,260.18 279.55,265.29 			"/>
        </g>
      </g>
      <g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="208.3,249.56 205.59,244.99 274.14,206.39 276.85,210.97 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="278.15,234.38 247.79,226.44 249.19,221.33 279.55,229.26 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="251.11,224.57 245.87,223.21 254,193.59 259.25,194.96 			"/>
        </g>
      </g>
      <g>
        <g>
          <rect x="204.24" y="170.09" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  width="5.42" height="77.19"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="208.86,202.36 205.03,198.62 227.25,176.95 231.08,180.69 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="205.03,202.36 182.8,180.69 186.63,176.95 208.86,198.62 			"/>
        </g>
      </g>
      <g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="205.59,249.56 137.05,210.97 139.76,206.39 208.3,244.99 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="162.78,224.57 154.65,194.96 159.88,193.59 168.01,223.21 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="135.75,234.38 134.33,229.26 164.69,221.33 166.1,226.44 			"/>
        </g>
      </g>
      <g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="139.76,288.17 137.05,283.58 205.59,244.99 208.3,249.56 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="164.69,273.22 134.33,265.29 135.75,260.18 166.1,268.11 			"/>
        </g>
        <g>
          <polygon fill="#FFFFFF" stroke="#FFFFFF" strokeWidth={10} strokeMiterlimit={10}  points="159.88,300.96 154.65,299.59 162.78,269.99 168.01,271.36 			"/>
        </g>
      </g>
    </g>
    </svg>

  )
}

const IceGripSvg = (props) => {
  const { className } = props
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" height={18} width={18} viewBox="0 0 393.98 358.65" className={className}>
    <polygon className="st0" points="22.12,353.62 370.21,353.62 196.17,10.09 " fill="#ffffff" stroke="#000000" strokeWidth="8" strokeMiterlimit="10" />
    <path d="M138.66,174.13c0,0-80.33,160.66-77.48,158.38s270.04,2.33,270.04,0.02s-90.01-184.61-90.01-184.61l-5.7,64.95l-13.1-16.52
      l-10.82,35.32l-6.84-16.52l-14.24,82.61l-36.46-105.4l-26.78,26.21L138.66,174.13z"/>
    </svg>
  )
}

const SilenceSvg = (props) => {
  // NOTE: source https://www.veryicon.com/icons/miscellaneous/background-basic-version-icon-library/43-mute.html
  const { className, vAlign } = props
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" style={{'width': '18px', 'height': '18px', 'verticalAlign': vAlign || 'middle', 'fill': 'currentColor', 'overflow': 'hidden'}} viewBox="0 0 1024 1024" className={className}>
      <path d="M515.756 621.32v179.391L441.1 732.859 318.837 621.685a37.46 37.46 0 0 0-25.169-9.714l-113.981 0.036-0.369-239.826h87.299l-74.687-74.687h-12.612c-41.107 0.164-74.341 33.553-74.318 74.651v239.862c0 41.171 33.348 74.651 74.318 74.651h99.929L441.1 833.808l59.382 53.965c14.977 13.596 29.165 17.387 40.332 17.387 8.621 0 15.496-2.26 19.455-4.028 9.113-4.028 30.245-17.241 30.245-52.981V696.08l-74.758-74.76zM846.634 540.729c0 72.792-18.663 125.298-39.116 161.239l52.156 52.161c29.753-45.873 58.512-115.439 58.512-213.436 0-199.056-123.02-281.288-128.283-284.678a35.316 35.316 0 0 0-26.859-4.848 35.397 35.397 0 0 0-22.289 15.747c-10.689 16.749-6.087 38.984 10.384 50.119 3.845 2.605 95.495 66.011 95.495 223.696z"  />
      <path d="M647.697 428.133c2.278 1.185 55.865 29.416 55.865 109.935 0 20.759-3.012 38-7.463 52.47l54.616 54.621c13.733-26.828 24.363-61.51 24.363-107.055 0-127.905-92.616-173.577-96.534-175.472v0.036a35.383 35.383 0 0 0-27.128-1.294 35.349 35.349 0 0 0-20.039 18.316c-8.475 17.916-1.267 39.312 16.32 48.443zM417.558 312.002l23.511-21.378 74.687-67.889V410.2l74.76 74.76V175.313c0-24.695-11.35-44.415-30.359-52.853-9.145-4.028-33.275-10.789-59.747 13.304l-59.309 53.91-76.405 69.456 52.862 52.872zM829.266 866.596c-9.55 0-19.1-3.645-26.39-10.935l-634.53-634.53c-14.58-14.58-14.58-38.2 0-52.78 14.58-14.58 38.2-14.58 52.78 0l634.53 634.529c14.58 14.58 14.58 38.2 0 52.78-7.29 7.291-16.84 10.936-26.39 10.936z"  />
    </svg>
  )
}

const ElectricVehicleSvg = (props) => {
  const { className, vAlign } = props
  return (
    <svg version="1.1" x="0px" y="0px" style={{'width': '18px', 'height': '18px', 'verticalAlign': vAlign || 'middle', 'fill': 'currentColor', 'overflow': 'hidden'}} viewBox="0 0 500 500" className={className}>
      <path d="M 113 152 m -248.541 0 a 248.541 248.541 0 1 0 497.082 0 a 248.541 248.541 0 1 0 -497.082 0 Z M 113 152 m -175.047 0 a 175.047 175.047 0 0 1 350.094 0 a 175.047 175.047 0 0 1 -350.094 0 Z" transform="matrix(-0.787924, 0.615773, -0.615773, -0.787924, 432.547791, 299.565125)" />
      <path d="M 296.258 89.775 L 184.818 271.968 L 246.14 273.147 L 208.993 414.067 L 323.38 227.157 L 260.836 227.157 L 270.157 190.81 Z" style={{'paintOrder': 'fill', 'fillRule': 'nonzero'}} />
    </svg>
  )
}

export {
  TyreTypeSvg,
  SnowflakeSvg,
  SunSvg,
  NoWinterSvg,
  EuWinterSvg,
  StuddedSvg,
  WheelBuilderActiveItemSvg,
  WheelBuilderSelectedItemSvg,
  WheelBuilderNormalItemSvg,
  CheckedSvg,
  UncheckedSvg,
  GripGradeSvg,
  FuelGradeSvg,
  NoiseGradeSvg,
  CartSvg,
  RadioCheckedSvg,
  RadioUncheckedSvg,
  StarSvg,
  IceGripSvg,
  SnowGripSvg,
  SilenceSvg,
  ElectricVehicleSvg,
}
